export enum EHomeSectionName {
  WELCOME_SCREEN = "welcome_screen",
  WHATS_HAPPENING = "whats_happening",
  CLIENTS_INDUSTRIES = "clients_industries",
  WHY_CHOOSE_US = "why_choose_us",
  WHAT_PEOPLE_SAY = "what_people_say",
  TAILORED_SOLUTIONS = "tailored_solutions",
  FOOTER = "footer",
}
